
export const createButton = (
    innerPath = '/', 
    label = 'Test' 
) => {

    return `<p><a href=${ process.env.REACT_APP_HOMEPAGE + innerPath }>` +
        "<button style='background:#87CEEB;padding:4px 9px;cursor:pointer;'>" + 
            label + 
        "</button></a></p>"
}